import { Component } from '@angular/core';
import { MigrationsCucmHuntListsPollingContext } from '../services/cisco/migrations-cucm-hunt-lists-polling.context';
import { MigrationsCucmHuntListsContext } from '../services/cisco/migrations-cucm-hunt-lists.context';
import { MigrationsCucmDirectoryNumberContext } from '../services/cisco/migrations-cucm-directory-number.context';
import { MigrationsCucmDirectoryNumbersPollingContext } from '../services/cisco/migrations-cucm-directory-numbers-polling.context';
import { MigrationsCucAutoAttendantsContext } from '../services/cisco/migrations-cuc-auto-attendants.context';
import { MigrationsCucAutoAttendantsPollingContext } from '../services/cisco/migrations-cuc-auto-attendants-polling.context';

@Component({
  selector: 'ziro-migrations-cisco',
  templateUrl: 'migrations-cisco.component.html',
  standalone: false,
  providers: [
    MigrationsCucmHuntListsPollingContext,
    MigrationsCucmHuntListsContext,
    MigrationsCucmDirectoryNumbersPollingContext,
    MigrationsCucmDirectoryNumberContext,
    MigrationsCucAutoAttendantsContext,
    MigrationsCucAutoAttendantsPollingContext,
  ],
})
export class MigrationsCiscoComponent {}
